const ADJUST_LINK = 'https://app.adjust.com/1dmakofi';
export const IOS_ADJUST_LINK = ADJUST_LINK;
export const ANDROID_ADJUST_LINK = ADJUST_LINK;
